import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SubMenuItem } from '@shared/components/header-sub-menu/header-sub-menu.component';
import { Subject, takeUntil } from 'rxjs';
import { InsightsService } from '../../../shared/services/insights.service';
import { UserService } from '../../../shared/services/user.service';
import { DialogAccountGroupsComponent } from './groups/dialog-account-groups/dialog-account-groups.component';

export interface IAccountAccess {
	groupIds: string[];
	name: string;
}

@Component({
	selector: 'app-account',
	templateUrl: './account.component.html',
	styleUrls: ['./account.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AccountComponent implements OnInit, OnDestroy {
	displayedColumns: string[] = ['name', 'groups'];
	dataSource = new MatTableDataSource();
	isLoading = true;
	userAccount: IAccountAccess = { groupIds: [], name: '' };
	data: IAccountAccess[] = [];
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public dialog: MatDialog,
		private insightsService: InsightsService,
		private userService: UserService,
	) {}

	public favoriteItems: SubMenuItem[] = [
		{
			icon: () => 'acies_edit',
			text: () => 'insights.administration.account.editbtn',
			click: () => this.editGroups(),
		},
	];

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	ngOnInit(): void {
		this.data = [];
		this.data.push(this.userAccount);
		this.dataSource.data = this.data;
		const account = this.userService.account;
		if (account !== undefined && account != null) {
			this.userAccount.name = `${account.organization.name} - ${account.name}`;
		}
		this.insightsService
			.fetchAccount()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data) => {
				if (data && data.result) {
					this.userAccount.groupIds = data.result.groupIds;
					this.isLoading = false;
				} else {
					this.userAccount.groupIds = [];
					this.isLoading = false;
				}
			});
	}

	editGroups() {
		console.log(`open edit groups dialog: ${JSON.stringify(this.userAccount)}`);
		const dialogRef = this.dialog.open(DialogAccountGroupsComponent, {
			width: '700px',
			data: this.userAccount,
		});

		dialogRef
			.afterClosed()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(() => {
				this.isLoading = true;
				this.userAccount = {
					groupIds: [],
					name: this.userAccount.name,
				};
				this.data.pop();
				this.insightsService
					.fetchAccount()
					.pipe(takeUntil(this.unsubscribe))
					.subscribe((data) => {
						console.log('fetching new data');
						this.userAccount.groupIds = data.result?.groupIds;
						this.data.push(this.userAccount);
						this.dataSource.data = this.data;
						this.isLoading = false;
					});
			});
	}
}
